import { Workspace, listWorkspace } from '@goldcast/api/backend';
import logger from '@goldcast/logger';
import { Module } from 'vuex';

interface WorkspaceState {
  workspaces: Workspace[];
  workspaceNameIdMap: Record<string, string>;
}

const workspaceModule: Module<WorkspaceState, any> = {
  namespaced: true,

  state: {
    workspaces: [],
    workspaceNameIdMap: {}
  },

  getters: {
    getWorkspaces: state => state.workspaces,
    getWorkspaceNameIdMap: state => state.workspaceNameIdMap,
    getWorkspaceById: state => (id: string) => state.workspaces.find(workspace => workspace.id === id)
  },

  mutations: {
    SET_WORKSPACES(state, workspaces: Workspace[]) {
      state.workspaces = workspaces;
    },
    SET_WORKSPACE_NAME_ID_MAP(state, workspaceNameIdMap: Record<string, string>) {
      state.workspaceNameIdMap = workspaceNameIdMap;
    }
  },

  actions: {
    async fetchAllWorkspaces({ commit, rootGetters }) {
      try {
        const currentOrg = rootGetters['org/getCurrentOrg'];
        const workspaces = await listWorkspace({
          queryParams: {
            organization: currentOrg.id,
            show: 'all',
            search: '',
            ordering: 'name'
          }
        });
        commit('SET_WORKSPACES', workspaces);
        commit(
          'SET_WORKSPACE_NAME_ID_MAP',
          (workspaces as Workspace[]).reduce((acc, workspace) => {
            acc[workspace.id] = workspace.name;
            return acc;
          }, {})
        );
      } catch (error) {
        logger.error(error);
        throw error;
      }
    }
  }
};

export default workspaceModule;
